// This module MUST be imported before any jQuery plugins.
// ES modules execute in dependency order, so importing this first
// ensures window.$ exists before jQuery plugins try to use it.
import jQuery from 'jquery/dist/jquery.min.js';

window.jQuery = window.$ = jQuery;
